var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ui segment" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "ui stretched two column grid" }, [
        _c(
          "div",
          { staticClass: "sixteen wide column" },
          [
            _c("observed-property-info-panel-component", {
              attrs: { observationsDetail: _vm.observationsDetail }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.isProcedureNull
              ? _c("sensors-info-panel-component", {
                  attrs: { observationsDetail: _vm.observationsDetail }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("observation-location-info-panel-component", {
              attrs: {
                featureOfInterest:
                  _vm.observationsDetail[0].observation.featureOfInterest
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ui segment" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "ui stretched two column grid" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("dataset-identification-info-panel-component", {
              attrs: { dataset: _vm.observationsDetail[0].dataset }
            }),
            _vm._v(" "),
            _c("contacts-info-panel-component", {
              attrs: {
                contacts: _vm.observationsDetail[0].dataset.metadata.contacts
              }
            }),
            _vm._v(" "),
            _c("dateset-temporal-extent-info-panel-component", {
              attrs: {
                temporalExtent:
                  _vm.observationsDetail[0].dataset.metadata.temporalExtent
              }
            }),
            _vm._v(" "),
            _c("dataset-spatial-extent-info-panel-component", {
              attrs: {
                spatialExtent:
                  _vm.observationsDetail[0].dataset.metadata.spatialExtent
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("data-constraint-info-panel-component", {
              attrs: {
                dataConstraint:
                  _vm.observationsDetail[0].dataset.metadata.dataConstraint
              }
            }),
            _vm._v(" "),
            _c("geology-climate-info-panel-component", {
              attrs: {
                geologies:
                  _vm.observationsDetail[0].dataset.metadata
                    .portalSearchCriteria.geologies,
                climates:
                  _vm.observationsDetail[0].dataset.metadata
                    .portalSearchCriteria.climates
              }
            }),
            _vm._v(" "),
            _c("online-resource-info-panel-component", {
              attrs: {
                onlineResource:
                  _vm.observationsDetail[0].dataset.metadata.onlineResource
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ui segment" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "ui stretched two column grid" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("producer-identification-info-panel-component", {
              attrs: { producer: _vm.observationsDetail[0].producer }
            }),
            _vm._v(" "),
            _c("producer-contacts-info-panel-component", {
              attrs: { producer: _vm.observationsDetail[0].producer }
            }),
            _vm._v(" "),
            _c("producer-online-resource-info-panel-component", {
              attrs: { producer: _vm.observationsDetail[0].producer }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("producer-fundings-info-panel-component", {
              attrs: { fundings: _vm.observationsDetail[0].producer.fundings }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "ui ribbon label" }, [
      _c("h1", [_vm._v("Measurement")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "ui ribbon label" }, [
      _c("h1", [_vm._v("Dataset")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "ui ribbon label" }, [
      _c("h1", [_vm._v("Producer")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }